var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-container" },
    [
      _c("div", {
        staticClass: "legend",
        domProps: { innerHTML: _vm._s(_vm.legend) }
      }),
      _vm._v(" "),
      _vm.loaded
        ? _c("line-chart", {
            attrs: { chartdata: _vm.chartData, options: _vm.options },
            on: { generated: _vm.setLegend }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }